import { ChemistryResult } from "../../../../models/lab.models";

export const processChemistryData = (chemistries: ChemistryResult[]) => {
  if (!chemistries?.length) return [];

  const sampleMap = new Map<number | null, any>();

  const presentElements = new Set<string>();
  chemistries.forEach((row) => {
    if (row.ElementName) {
      presentElements.add(row.ElementName);
    }
  });

  chemistries.forEach((row) => {
    if (!row.ElementName || !row.ChemistrySampleId) return;

    if (!sampleMap.has(row.ChemistrySampleId)) {
      sampleMap.set(row.ChemistrySampleId, {
        ChemistrySampleId: row.ChemistrySampleId,
        Sample: row.SampleCode,
        SampleTypeName: row.SampleTypeName,
        SampleSequence: row.SampleSequence,
        Reported: row.Reported,
        MinValue: row.MinValue,
        MaxValue: row.MaxValue,
        IsManual: row.IsManual,
        IsDuplicate: row.IsDuplicate ?? false,
      });
    }

    const sample = sampleMap.get(row.ChemistrySampleId);

    sample[row.ElementName] = row.Value ?? "-";
    sample[`${row.ElementName}_Status`] = row.Status ?? "Unknown";
    sample[`${row.ElementName}_Id`] = row.ElementId ?? null;
  });

  const regularRows = Array.from(sampleMap.values());

  // Only highlight the latest sample (most recent Reported timestamp)
  let latestSampleId: number | null = null;
  let latestReported = 0;

  for (const row of regularRows) {
    if (row.Reported) {
      const reportedTime = new Date(row.Reported).getTime();
      if (reportedTime > latestReported) {
        latestReported = reportedTime;
        latestSampleId = row.ChemistrySampleId;
      }
    }
  }

  for (const row of regularRows) {
    if (row.ChemistrySampleId !== latestSampleId) {
      for (const element of presentElements) {
        if (row[`${element}_Status`]) {
          row[`${element}_Status`] = "Within";
        }
      }
    }
  }

  const limitRows = [
    {
      Sample: "MIN",
      ValueType: "MinValue",
      ...Array.from(presentElements).reduce(
        (acc, element) => {
          const elementData = chemistries.find(
            (row) => row.ElementName === element,
          );
          acc[element] = elementData?.MinValue ?? "-";
          return acc;
        },
        {} as Record<string, number | string>,
      ),
    },
    {
      Sample: "MAX",
      ValueType: "MaxValue",
      ...Array.from(presentElements).reduce(
        (acc, element) => {
          const elementData = chemistries.find(
            (row) => row.ElementName === element,
          );
          acc[element] = elementData?.MaxValue ?? "-";
          return acc;
        },
        {} as Record<string, number | string>,
      ),
    },
  ];

  return [...regularRows, ...limitRows];
};
